import styles from './index.module.css'
import { RadioGroup, Radio } from '@appkit4/react-components/radio'
import classnames from 'classnames'

export const View = ({ itemList, className, ...props }) => {
    return (
        <RadioGroup className={classnames(className, styles.default)} {...props}>
            {itemList.map(({ value, label, ...props }) => {
                return (
                    <Radio className={styles.radio_item} key={value} value={value} {...props}>
                        {label}
                    </Radio>
                )
            })}
        </RadioGroup>
    )
}
